import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Button as ReakitButton } from 'reakit/Button';
import classNames from 'classnames';

import Spinner from 'components/spinner';

import './style.css';

const Button = React.forwardRef(
  (
    {
      hierarchy,
      className,
      children,
      size,
      looks,
      status,
      loading,
      href,
      disabled,
      shadow,
      icon: Icon,
      ...rest
    },
    ref
  ) => {
    const customClassName = classNames(
      'button',
      className,
      `-${hierarchy}`,
      `-${size}`,
      `-${looks}`,
      {
        '-shadow': shadow,
        '-disabled': disabled,
        [`-${status}`]: status != null,
      }
    );

    const BaseButton = href ? Link : ReakitButton;

    return (
      <BaseButton
        {...rest}
        ref={ref}
        className={customClassName}
        to={href}
        disabled={disabled}
      >
        {Icon && !loading ? <Icon className="button-icon" /> : null}
        {loading ? <Spinner className="button-icon" /> : null}
        {children}
      </BaseButton>
    );
  }
);

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  looks: PropTypes.oneOf(['normal', 'text']),
  status: PropTypes.oneOf(['success', 'warning', 'danger']),
  hierarchy: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  size: PropTypes.oneOf(['s', 'm', 'l']),
  icon: PropTypes.func,
  loading: PropTypes.bool,
  href: PropTypes.string,
  disabled: PropTypes.bool,
  shadow: PropTypes.bool,
};

Button.defaultProps = {
  hierarchy: 'primary',
  className: null,
  children: null,
  size: 'm',
  looks: 'normal',
  icon: null,
  loading: false,
  href: null,
  status: null,
  disabled: false,
  shadow: true,
};

export default Button;
